<template>
  <div id="cloud">
    <div class="main">
      <el-menu
        v-if="activeIndex != 3"
        :default-active="activeIndex"
        class="el-menu-demo tel_menu"
        mode="horizontal"
      >
        <el-menu-item @click="activeIndex = '1'" class="munu_item" index="1">密码验证登录</el-menu-item>
        <el-menu-item @click="activeIndex = '2'" class="munu_item" index="2">手机验证码登录</el-menu-item>
      </el-menu>
      <h3 class="bind_phone" v-if="activeIndex == 3">绑定手机</h3>
      <!-- 账号登录 -->
      <my-login @toBind="swtchState('3')" v-if="activeIndex == '1'"></my-login>
      <!-- 手机登录 -->
      <telLogin v-if="activeIndex == '2'"></telLogin>
      <my-bind @success="swtchState('1')" v-if="activeIndex == '3'"></my-bind>
    </div>
    <div class="clearfix cloud_footer">
      <span style="color:#999">
        还没账户?
        <span @click="toPath('signup')" class="pointer" style="color:#999">立即注册</span>
      </span>
      <span @click="toPath('forget')" class="fr pointer" style="color:#999">忘记密码?</span>
    </div>
  </div>
</template>

<script>
import { setCookie } from "@/uitls/index.js";
import myLogin from "./components/login";
import telLogin from "./components/telLogin";
import myBind from "./components/bind";
export default {
  data() {
    return {
      // 切换状态
      activeIndex: "1"
    };
  },
  components: {
    myLogin,
    telLogin,
    myBind
  },
  methods: {
    // 跳转注册和忘记密码
    toPath(name) {
      if (name == "signup") {
        window.open(
          process.env.SSO_SRC + "signup?redirect_url=" + window.location.href
        );
      } else if (name == "forget") {
        window.open(
          process.env.SSO_SRC + "recovery?redirect_url=" + window.location.href
        );
      }
    },
    swtchState(number) {
      this.activeIndex = number;
    }
  },
  mounted() {
    // 如果页面是独立的 未被iframe引用 那么返回登录页
    // if(window.parent == window) {
    //     this.$router.push('/login')
    // }
  },
  computed: {}
};
</script>


<style lang="scss" scoped>
#cloud {
  height: 100%;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
  }
}
.cloud_footer {
  background-color: #f2f5f8;
  padding: 0 50px;
  height: 60px;
  line-height: 60px;
}
.tel_menu {
  padding: 30px 0;
  width: 80%;
  margin: 0 auto;
  border: none !important;

  .munu_item {
    width: 50%;
    text-align: center;
    font-size: 16px;
    &.is-active {
      border: none;
      position: relative;
      &:after {
        content: "";
        width: 26px;
        height: 3px;
        background-color: #ec4452;
        border-radius: 5px;
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
      }
    }
  }
}
.bind_phone {
  height: 120px;
  line-height: 120px;
  width: 80%;
  margin: 0 50px;
}
.el-menu--horizontal > .el-menu-item {
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/views/cloudStructure/index.vue